import { render, staticRenderFns } from "./books-shelf.vue?vue&type=template&id=5fb73f08&scoped=true&"
import script from "./books-shelf.vue?vue&type=script&lang=js&"
export * from "./books-shelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb73f08",
  null
  
)

export default component.exports